<template>
  <dara-row class="d-flex align-items-center">
    <dara-col :xs="24" :span="8">
      <dara-rating
        v-model="rating"
        :disabled="disabled"
        @change="onSaveRating" />
    </dara-col>
  </dara-row>
</template>

<script>
import { getCurrentStoredUser } from '@/modules/user/user.service';
import { getUserArticleRating, saveArticleRating } from '@/modules/article/article.service';

export default {
  name: 'DaraArticleRating',
  props: {
    article: Object,
  },
  data() {
    return {
      rating: null,
    };
  },
  computed: {
    disabled() {
      return !!this.rating;
    },
  },
  mounted() {
    this.fetchRating();
  },
  methods: {
    fetchRating() {
      getUserArticleRating(this.article.id).then(data => {
        const { value } = data;
        if (value) {
          this.rating = value;
        }
      });
    },
    onSaveRating(rating) {
      const aux = {
        value: rating,
        article_id: this.article.id,
        user_id: getCurrentStoredUser().id,
      };
      saveArticleRating(aux)
        .then(({ data }) => {
          this.rating = data.value;
        });
    },
  },
};
</script>
